import React, { useState } from "react";
import { X, Save, CreditCard, Building2, Smartphone, Wallet } from "lucide-react";

export default function PaymentAccountsForm({ onSave, onClose, item }) {
  const [formData, setFormData] = useState(
    item || {
      account_name: "",
      account_type: "upi",
      upi_id: "",
      payment_gateway: "",
      bank_name: "",
      account_number: "",
      account_holder_name: "",
      terminal_id: "",
      merchant_id: "",
      machine_provider: "",
      counter_location: "",
      description: "",
      is_active: true,
      is_default: false,
      display_order: "",
    }
  );

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.account_name.trim()) {
      alert("Account Name is required");
      return;
    }
    if (!formData.account_type.trim()) {
      alert("Account Type is required");
      return;
    }
    onSave(formData);
  };

  const getAccountTypeIcon = () => {
    switch (formData.account_type) {
      case "upi":
        return <Smartphone className="w-4 h-4 text-slate-600" />;
      case "bank":
        return <Building2 className="w-4 h-4 text-slate-600" />;
      case "card_machine":
        return <CreditCard className="w-4 h-4 text-slate-600" />;
      case "cash_counter":
        return <Wallet className="w-4 h-4 text-slate-600" />;
      default:
        return null;
    }
  };

  const renderFields = () => {
    switch (formData.account_type) {
      case "upi":
        return (
          <>
            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                UPI ID
              </label>
              <input
                type="text"
                value={formData.upi_id}
                onChange={(e) => handleChange("upi_id", e.target.value)}
                placeholder="example@upi"
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-100 transition-all"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                Payment Gateway
              </label>
              <select
                value={formData.payment_gateway}
                onChange={(e) => handleChange("payment_gateway", e.target.value)}
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-100 transition-all"
              >
                <option value="">Select Gateway</option>
                <option value="Google Pay">Google Pay</option>
                <option value="PhonePe">PhonePe</option>
                <option value="Paytm">Paytm</option>
                <option value="Bhim">Bhim</option>
              </select>
            </div>
          </>
        );

      case "bank":
        return (
          <>
            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                Bank Name
              </label>
              <input
                type="text"
                value={formData.bank_name}
                onChange={(e) => handleChange("bank_name", e.target.value)}
                placeholder="ICICI Bank"
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-100 transition-all"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                Account Number
              </label>
              <input
                type="text"
                value={formData.account_number}
                onChange={(e) => handleChange("account_number", e.target.value)}
                placeholder="XXXXXXXXXXXX"
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-100 transition-all"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                Account Holder Name
              </label>
              <input
                type="text"
                value={formData.account_holder_name}
                onChange={(e) => handleChange("account_holder_name", e.target.value)}
                placeholder="John Doe"
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-100 transition-all"
              />
            </div>
          </>
        );

      case "card_machine":
        return (
          <>
            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                Terminal ID
              </label>
              <input
                type="text"
                value={formData.terminal_id}
                onChange={(e) => handleChange("terminal_id", e.target.value)}
                placeholder="Enter terminal ID"
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-100 transition-all"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                Merchant ID
              </label>
              <input
                type="text"
                value={formData.merchant_id}
                onChange={(e) => handleChange("merchant_id", e.target.value)}
                placeholder="Enter merchant ID"
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-100 transition-all"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                Machine Provider
              </label>
              <input
                type="text"
                value={formData.machine_provider}
                onChange={(e) => handleChange("machine_provider", e.target.value)}
                placeholder="Pine Labs, Mswipe, Paytm PoS"
                className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-100 transition-all"
              />
            </div>
          </>
        );

      case "cash_counter":
        return (
          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">
              Counter Location
            </label>
            <input
              type="text"
              value={formData.counter_location}
              onChange={(e) => handleChange("counter_location", e.target.value)}
              placeholder="Main Counter, Drive-thru Counter"
              className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-100 transition-all"
            />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="fixed inset-0 bg-slate-900/20 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl max-h-[95vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="bg-teal-50 border-b border-teal-200 px-6 py-4 flex items-center justify-between rounded-t-2xl">
          <div className="flex items-center gap-3">
            <div className="bg-teal-100 w-10 h-10 rounded-full flex items-center justify-center">
              <CreditCard className="w-5 h-5 text-teal-600" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-gray-900">
                {item ? "Edit Payment Account" : "Add Payment Account"}
              </h2>
              <p className="text-xs text-gray-500">
                Configure your payment account details
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-teal-100 rounded-lg transition-colors group"
          >
            <X className="w-5 h-5 text-teal-600 group-hover:text-teal-800" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="flex-1 overflow-y-auto">
          <div className="p-6 space-y-5">
            {/* Basic Information Section */}
            <div className="space-y-3">
              <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider pb-2 border-b border-slate-200">
                Basic Information
              </h3>

              <div className="grid grid-cols-2 gap-4">
                {/* Account Name */}
                <div>
                  <label className="block text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                    Account Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.account_name}
                    onChange={(e) => handleChange("account_name", e.target.value)}
                    placeholder="e.g., Main UPI, ICICI Counter 1"
                    required
                    className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-100 transition-all"
                  />
                </div>

                {/* Account Type */}
                <div>
                  <label className="block text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                    Account Type <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <select
                      value={formData.account_type}
                      onChange={(e) => handleChange("account_type", e.target.value)}
                      required
                      className="w-full pl-12 pr-4 py-2.5 bg-white border border-slate-200 rounded-lg text-sm text-slate-800 focus:outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-100 transition-all appearance-none"
                    >
                      <option value="upi">UPI</option>
                      <option value="bank">Bank</option>
                      <option value="card_machine">Card Machine</option>
                      <option value="cash_counter">Cash Counter</option>
                    </select>
                    <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
                      {getAccountTypeIcon()}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Account Details Section */}
            {formData.account_type && (
              <div className="space-y-3">
                <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider pb-2 border-b border-slate-200">
                  Account Details
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  {renderFields()}
                </div>
              </div>
            )}

            {/* Additional Information & Settings Combined */}
            <div className="grid grid-cols-2 gap-6">
              {/* Left Column - Description & Display Order */}
              <div className="space-y-3">
                <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider pb-2 border-b border-slate-200">
                  Additional Information
                </h3>

                {/* Description */}
                <div>
                  <label className="block text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                    Description
                  </label>
                  <textarea
                    rows="3"
                    value={formData.description}
                    onChange={(e) => handleChange("description", e.target.value)}
                    placeholder="Add any additional notes"
                    className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-100 transition-all resize-none"
                  />
                </div>

                {/* Display Order */}
                <div>
                  <label className="block text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">
                    Display Order
                  </label>
                  <input
                    type="number"
                    value={formData.display_order}
                    onChange={(e) => handleChange("display_order", e.target.value)}
                    placeholder="1"
                    className="w-full px-4 py-2.5 bg-white border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:border-slate-400 focus:ring-2 focus:ring-slate-100 transition-all"
                  />
                  <p className="text-xs text-slate-500 mt-1.5">Lower numbers appear first</p>
                </div>
              </div>

              {/* Right Column - Settings */}
              <div className="space-y-3">
                <h3 className="text-xs font-bold text-slate-700 uppercase tracking-wider pb-2 border-b border-slate-200">
                  Settings
                </h3>

                <div className="space-y-3">
                  {/* Active Toggle */}
                  <label className="flex items-center gap-3 p-3.5 bg-slate-50 rounded-lg cursor-pointer hover:bg-slate-100 transition-colors group">
                    <input
                      type="checkbox"
                      checked={formData.is_active}
                      onChange={(e) => handleChange("is_active", e.target.checked)}
                      className="w-4 h-4 rounded border-slate-300 text-slate-700 focus:ring-2 focus:ring-slate-200 focus:ring-offset-0 cursor-pointer"
                    />
                    <div className="flex-1">
                      <span className="text-sm font-medium text-slate-800 group-hover:text-slate-900">
                        Active Account
                      </span>
                      <p className="text-xs text-slate-500 mt-0.5">
                        Enable this account for transactions
                      </p>
                    </div>
                  </label>

                  {/* Default Toggle */}
                  <label className="flex items-center gap-3 p-3.5 bg-slate-50 rounded-lg cursor-pointer hover:bg-slate-100 transition-colors group">
                    <input
                      type="checkbox"
                      checked={formData.is_default}
                      onChange={(e) => handleChange("is_default", e.target.checked)}
                      className="w-4 h-4 rounded border-slate-300 text-slate-700 focus:ring-2 focus:ring-slate-200 focus:ring-offset-0 cursor-pointer"
                    />
                    <div className="flex-1">
                      <span className="text-sm font-medium text-slate-800 group-hover:text-slate-900">
                        Set as Default
                      </span>
                      <p className="text-xs text-slate-500 mt-0.5">
                        Use as default for this account type
                      </p>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Actions */}
          <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3 rounded-b-2xl">
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-2.5 bg-white border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-5 py-2.5 bg-teal-600 text-white rounded-lg text-sm font-medium hover:bg-teal-700 transition-colors flex items-center gap-2"
            >
              <Save className="w-4 h-4" />
              {item ? "Update Account" : "Add Account"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
